/**
 * @generated SignedSource<<ccbf7038bc249ef39dd9bef68841a377>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type plainText_nativeIssueTable_PlainTextCell$data = {
  readonly text: string | null | undefined;
  readonly " $fragmentType": "plainText_nativeIssueTable_PlainTextCell";
};
export type plainText_nativeIssueTable_PlainTextCell$key = {
  readonly " $data"?: plainText_nativeIssueTable_PlainTextCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"plainText_nativeIssueTable_PlainTextCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "plainText_nativeIssueTable_PlainTextCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "f3885c34c9bef325f41889fe211cc3d3";

export default node;
